import { render, staticRenderFns } from "./klarna_pay.vue?vue&type=template&id=55583c44&scoped=true&"
import script from "./klarna_pay.vue?vue&type=script&lang=js&"
export * from "./klarna_pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55583c44",
  null
  
)

export default component.exports